import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { transferInvoiceDialog } from "../../styles/mui/tableListTheme";
import Stack from "@mui/material/Stack";
import _ from "lodash";
import { ThemeProvider } from "@emotion/react";

export default function EmployeeBenefitDialog(props) {
  const { open, onClose, layout, size, onSubmit, mode, title } = props;

  return (
    <Dialog
      maxWidth={size}
      open={open}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <Box sx={{ mt: 2 }} />
      <DialogTitle>
        <Stack direction="row" justifyContent={"space-between"}>
          {title}
        </Stack>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <ThemeProvider theme={transferInvoiceDialog}>{layout}</ThemeProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>取消</Button>
        <Button onClick={() => onSubmit()}>
          {mode === "create" ? "新增" : "修改"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
